exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_wks-ext.js
// module id = 139
// module chunks = 0